import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  selector: '[mbsTextEllipsisAppend]'
})
export class TextEllipsisAppendDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  public readonly hide = input<boolean>(false);
}
